import type { DataDrivenPropertyValueSpecification } from 'mapbox-gl';

import { LocationType } from '../types';
import type { MapThemeColors } from '../utils/color-scale';
import type { ChoroplethLayerConfig } from './ChoroplethConfig';

export function buildFillExpression(
  config: ChoroplethLayerConfig,
  data: Record<string, number>,
  colorScale: (value: number) => string,
  colors: MapThemeColors
): DataDrivenPropertyValueSpecification<string> | string {
  const isMetro = config.id === LocationType.METRO_AREA;
  const fallbackFill = isMetro ? colors.neutral : colors.noDataFill;

  if (Object.keys(data).length === 0) {
    return fallbackFill;
  }

  const expr: DataDrivenPropertyValueSpecification<string> = [
    'match',
    ['to-string', ['get', config.propertyName]],
  ];
  Object.entries(data).forEach(([name, val]) => {
    if (!name || name === '' || val === undefined || val === null) return;
    expr.push(name, colorScale(val) ?? fallbackFill);
  });
  expr.push(fallbackFill);
  return expr;
}
